export const AbFeatureNames = {
  SIMONLYPLUS_UPSELL_DESIGN: 'SIMONLYPLUS_UPSELL_DESIGN',
  PX_ADDONS: 'PX_ADDONS'
};
